export default __webpack_public_path__ + "static/media/auto-mpg.f279f73f.svg";